const GOOGLE_LOCALE_MAPPING = {
  'es-LA': 'es-419',
  fr: 'fr-FR',
};

const APPLE_LOCALE_MAPPING = {
  cs: 'cz',
  da: 'dk',
  el: 'gr',
  'es-LA': 'mx',
  'es-ES': 'es',
  et: 'ee',
  'fr-CA': 'fr/ca',
  hi: 'in',
  ja: 'jp',
  ko: 'kr',
  ma: 'my',
  'pt-BR': 'br',
  sl: 'si',
  sv: 'se',
  vi: 'vn',
  'zh-CN': 'cn',
  'zh-TW': 'tw',
};

const FB_LOCALE_MAPPING = {
  en: 'www',
  bg: 'bg-bg',
  cs: 'cs-cz',
  da: 'da-dk',
  de: 'de-de',
  el: 'el-gr',
  et: 'et-ee',
  fi: 'fi-fi',
  fr: 'fr-fr',
  it: 'it-it',
  lt: 'lt-lt',
  lv: 'lv-lv',
  nl: 'nl-nl',
  no: 'no-no',
  pl: 'pl-pl',
  pt: 'pt-pt',
  ro: 'ro-ro',
  sk: 'sk-sk',
  sl: 'sl-sl',
  sv: 'sv-se',
};

const TWITTER_LOCALE_MAPPING = {
  'es-LA': 'es',
  'es-ES': 'es',
  'fr-CA': 'fr',
  'fr-FR': 'fr',
};

module.exports = {
  GOOGLE_LOCALE_MAPPING,
  APPLE_LOCALE_MAPPING,
  FB_LOCALE_MAPPING,
  TWITTER_LOCALE_MAPPING,
};
